module.exports = __webpack_public_path__ + "static/media/3.88b19af0.mp3";